import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import sounds from 'src/lib/sounds';
import { View } from '@play-co/timestep-core/ui';
import { Avatar } from '../components/shared/Avatar';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { energyGiftConfirmation as ui } from './PopupGiftsConfirmation.style';
import { FlexBoxView, getFlexNode } from '@play-co/timestep-core/flexbox';
import { GiftType } from 'src/replicant/gifts';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupGiftsConfirmationMulti extends PopupBasic<
  (canceled: boolean) => void
> {
  private avatars: Avatar[];

  constructor(opts: { superview: View; close: (canceled: boolean) => void }) {
    super({
      superview: opts.superview,
      close: () => opts.close(true),
      ...ui.rootMulti,
      tracking: { feature: 'profile', $subFeature: 'popup-energyGift' },
      titleIcon: {
        image: 'assets/ui/gifts/icons/gifts_popup_icon.png',
      },
    });

    this.buttonClose.removeFromSuperview();

    // Top Separator
    new View({
      superview: this.box,
      ...ui.separatorMulti,
      x: this.box.style.width / 2,
    });

    this.message.updateOpts({
      superview: this.box,
      ...ui.messageMulti,
      x: this.box.style.width / 2,
    });

    const frame = new FlexBoxView({
      superview: this.box,
      ...ui.frameMulti,
      width: this.box.style.width * 0.9,
      x: this.box.style.width / 2,
    });

    this.avatars = Array(10)
      .fill(null)
      .map(() => {
        const avatar = new Avatar({
          superview: frame,
          width: 85,
          height: 85,
          centerOnOrigin: false,
        });
        getFlexNode(avatar).marginHorizontal = 5;
        getFlexNode(avatar).marginVertical = 5;

        return avatar;
      });

    new LangBitmapFontTextView({
      superview: this.box,
      ...ui.warningMulti,
      x: this.box.style.width / 2,
      localeText: () => i18n('gifts.popupConfirmationMulti.warning'),
    });

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.cancel,
      ...ui.button,
      superview: this.box,
      x: this.box.style.width / 4,
      y: this.box.style.height - 25 - 100 / 2,
      localeText: () => i18n('basic.cancel'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        return opts.close(false);
      },
      tracking: { feature: 'profile', $subFeature: 'popup-energyGift-close' },
    });

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      ...ui.button,
      x: (this.box.style.width / 4) * 3,
      y: this.box.style.height - 25 - 100 / 2,
      localeText: () => i18n('basic.ok'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(true);
      },
      tracking: { feature: 'profile', $subFeature: 'popup-energyGift-ok' },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/gifts/icons/gifts_popup_icon.png']);
  }

  private getGiftType(): GiftType {
    return 'gems';
  }

  public init({
    avatars,
    title,
    message,
  }: {
    avatars: string[];
    title?: string;
    message?: string;
  }) {
    const messageKeyMap: Record<GiftType, string> = {
      energy: 'gifts.popupConfirmationMulti.messageEnergy',
      bPoint: 'gifts.popupConfirmationMulti.message',
      gems: 'gifts.popupConfirmationMulti.messageGems',
    };
    const messageKey = messageKeyMap[this.getGiftType()];
    const titleKey = 'gifts.popupConfirmationMulti.title';
    super.init({
      title: title ?? i18n(titleKey),
      message:
        message ??
        i18n(messageKey, {
          numFriends: avatars.length,
        }),
    });

    this.avatars.forEach((avatar, i) => {
      if (!avatars[i]) {
        avatar.hide();
        return;
      }

      avatar.show();
      avatar.updateImage(avatars[i]);
    });
  }
}
